var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',{staticClass:"imgcontain",attrs:{"src":_vm.srcList[0] || _vm.goods_default,"preview-src-list":_vm.preview ? _vm.srcList : []},on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"image-slot",attrs:{"slot":"error"},slot:"error"},[_c('i',{staticClass:"el-icon-picture-outline"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }